import React from "react";
import NavBar from "../NavBar";
import CardRender from "../DashboardCardRender";
import DashboardTablesRender from "../DashboardTablesRender";
import { CRMCardData } from "../Dashboard card data";
import { INVENTORYDBSupplierTableData } from "../DashboardTablesData";
// import CRMPieChart from "./CRMComponent/CRMPieChart";
import { CRMDashTable } from "./CRMComponent/CRMDashTable";
// import CRMBarChart from "./CRMComponent/CRMBarChart";
import PieCircle from "../HR/HRComponent/piechart";
import SingleLineChart from "../SingleLineChart";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
// import BarLineChart from "../BarLineChart";
import StackedBarChart from "../StackedBarChart";
import { CRMBarData } from "../BarchartData";
import { CRMColorData } from "../BarColorData";
// import SecondBiChart from "../SecondBiChart";
import PieGraph from "../BI/PieGraph";
import TwoLineChart from "../TwoLineChart";
import DotsComponent from "../DotsComponent";
import { CRMLineData } from "../SingleLineChartData";
import PieCardRender from "../PieCardRender";
import GraphLabel1 from "../Components/GraphLabel1";
import GraphLabel3 from "../Components/GraphLabel3";
import GraphLabel2 from "../Components/GraphLabel2";
export default function CRMDashboard() {
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Customer Relationship Management</span>
          <span className="color"> &#62; </span>
          <span className="color"> Dashboard</span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h1>Dashboard</h1>
        <div id="Right-content-Down-Filters">
          <p>Till Now:</p>
          <label className="switch">
            <input type="checkbox" />
            <span className="slider"></span>
          </label>
          <div
            style={{
              "border-left": "1px solid rgba(128, 128, 128, 0.511)",
              height: "80%",
            }}
          ></div>
          <label htmlFor="Starting-month">Sort from:</label>
          <input type="date" id="Starting-month" />
          <label htmlFor="Ending-month">To:</label>
          <input type="date" placeholder="Ending month" id="Ending-month" />
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "60%",
            }}
          ></div>
        </div>
      </div>
      <div id="right-content-cards">
        <PieCardRender data={CRMCardData[0]} filling={fillingData1} pieColor={PIECOLORS1} pieIndicator={pieIndicator1}/>
        <CardRender comp={CRMCardData.slice(1,4)} />
        <PieCardRender data={CRMCardData[4]} filling={fillingData2} pieColor={PIECOLORS2} pieIndicator={pieIndicator2}/>
        <PieCardRender data={CRMCardData[5]} filling={fillingData3} pieColor={PIECOLORS3} pieIndicator={pieIndicator3}/>
      </div>
      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
          <div className="graph">
          <DotsComponent/>
            <div className="graph_heading">
              <h1 className="Graph_title">CUSTOMER AQUISITION</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel1 color = {"#394A7E"} value={'Expense'}/>
          <SingleLineChart data={CRMLineData}/>
        </div>
        <div className="dashboard-graph">
          <div className="graph">
          <DotsComponent/>
            <div className="chart-head">
              <h1 className="Graph_title">Lead By Source</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
          </div>
          <GraphLabel3 color={["#394A7E","#4E6DCB", "#20BF55"]} 
            value={['Social Media', 'Organic','Email']}
          />
          {/* <BarLineChart /> */}
          <StackedBarChart BarData={CRMBarData} ColorData={CRMColorData}/>

        </div>
      </div>
      {/* Here I rendered the dashboard table1 */} 
      <CRMDashTable />
      <div id="" className="Dashboard-graph-parent">
        <div className="dashboard-graph">
        <DotsComponent/>
        <div className="chart-head">
              <h1 className="Graph_title">CART ABANDONMENT FREQUENCY OF USERS</h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div>
            <span className="crm">
          <PieGraph />
          </span>
        </div>
        <div className="dashboard-graph">
          <div className="graph">
          <DotsComponent/>
            <div className="chart-head">
              <h1 className="Graph_title">AVERAGE RESPONSE TIME (in hours) </h1>
              <OpenInNewIcon
                style={{ fontSize: "16", marginLeft: "5" }}
              ></OpenInNewIcon>
            </div> 
          </div>   
            <GraphLabel2 color={["#527DFF","#3FD600"]} 
            value={['First Response Time', 'Resolution Time']}
            />
          <TwoLineChart />
        </div>
      </div>
    </>
  );
}
const fillingData1 = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 850 },
  { name: "Group C", value: 400 },

];
const PIECOLORS1 = ["#FFE754", "#F7762E", "#FFC700"];
const pieIndicator1 = ["#ECECEC","#FFC700", "#F7762E","#FFE754"]

const fillingData2 = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 850 },
  { name: "Group C", value: 400 },

];
const PIECOLORS2 = ["#FFE754", "#F7762E", "#FFC700"];
const pieIndicator2 = []

const fillingData3 = [
  { name: "Group A", value: 400 },
  { name: "Group B", value: 850 },
  { name: "Group C", value: 400 },

];
const PIECOLORS3 = ["#FFE754", "#F7762E", "#FFC700"];
const pieIndicator3 = ["#ECECEC","#FFC700", "#F7762E","#FFE754"]